import { createPluginSystemRunner } from "@prismicio/plugin-kit";
import { assertPluginsInitialized } from "../../lib/assertPluginsInitialized.js";
import { BaseManager } from "../BaseManager.js";
class PluginsManager extends BaseManager {
  _nativePlugins;
  constructor(prismicManager, config) {
    super(prismicManager);
    this._nativePlugins = config.nativePlugins ?? {};
  }
  async initPlugins() {
    const projectRoot = await this.project.getRoot();
    const prismicConfig = await this.project.getPrismicConfig();
    this.pluginSystemRunner = createPluginSystemRunner({
      project: {
        root: projectRoot,
        config: prismicConfig
      },
      nativePlugins: this._nativePlugins
    });
    await this.pluginSystemRunner.init();
  }
  dangerouslyCallHook = (...args) => {
    assertPluginsInitialized(this.pluginSystemRunner);
    return this.pluginSystemRunner.callHook(...args);
  };
}
export {
  PluginsManager
};
//# sourceMappingURL=PluginsManager.js.map
